import React from 'react';
import { identicon, initials } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import { Card, Col, Row } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const RankingObject = ({ username, team, points, position }) => {
  const teamLogo = createAvatar(team ? identicon : initials, {
    seed: team ? team : username,
    size: 100,
    backgroundColor: team ? [] : ['1e88e5']
  }).toDataUriSync();
  return (
    <Card
      className={classNames('mb-2', {
        'border-first': position == 1,
        'border-second': position == 2,
        'border-third': position == 3,
        'border-white': position > 3
      })}
    >
      <Card.Body>
        <Row className="justify-content-between">
          <Col className="d-flex align-items-center">
            <div className="text-center text-nowrap" style={{ width: '8%' }}>
              <h5 className="mb-0 text-700">{position}</h5>
            </div>
            <div className="avatar avatar-2xl mx-3">
              <img src={teamLogo} alt="" />
            </div>
            <div>
              <Link to={`/team/${username}`}>
                <h5 className="mb-0 lh-1 fw-semibold text-primary">{team}</h5>
              </Link>
              <h6 className="mb-0 text-700">{username}</h6>
            </div>
          </Col>
          <Col xs={'auto'} className="d-flex align-items-center">
            <h5 className="mb-0 lh-1 fw-semibold">
              <span className="text-800">{points}</span>
              <span className="text-700"> pt</span>
            </h5>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

RankingObject.propTypes = {
  username: PropTypes.string.isRequired,
  team: PropTypes.string,
  points: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired
};

export default RankingObject;
